import React, { useState } from 'react';
import { Copy, Check, Download, Megaphone, Image as ImageIcon } from 'lucide-react';

const IMAGES = [
  { file: '/campaign/hero-lanzamiento.jpg', label: 'Banner lanzamiento (LinkedIn / Facebook / X)', format: '1536×1024 horizontal' },
  { file: '/campaign/anuncio-cuadrado.jpg', label: 'Anuncio cuadrado (Instagram / Facebook feed)', format: '1024×1024 cuadrado' },
  { file: '/campaign/story-vertical.jpg', label: 'Story / Reel (Instagram / TikTok / WhatsApp Estados)', format: '1024×1536 vertical' },
];

const TEXTS = [
  {
    id: 'instagram',
    channel: 'Instagram / Facebook (post de lanzamiento)',
    text: `🚀 LANZAMOS NEURALIA 369\n\nImagina entrar a tu negocio y VER todo bajo control, ESCUCHAR a tu IA responder clientes con voz real y SENTIR que nada se te escapa.\n\nEso es Aynara, el corazón de Neuralia 369:\n✅ Responde a tus clientes por chat y por teléfono, con voz real\n✅ Detecta interés y agenda citas sola\n✅ Junta todos tus leads en un panel y te dice a quién llamar primero\n\nNo ofrecemos una IA suelta. Integramos una capa operativa completa para que tu negocio venda 24/7.\n\n🎧 Vive la Experiencia 3D y habla con Aynara:\n👉 neuralia369.com/experiencia\n\n#IA #Automatizacion #Negocios #InteligenciaArtificial #Neuralia369`,
  },
  {
    id: 'linkedin',
    channel: 'LinkedIn (post profesional)',
    text: `Hoy lanzamos Neuralia 369: la capa operativa de IA que une lo que toda empresa tiene disperso.\n\nDurante meses vimos el mismo patrón en pymes y clínicas: herramientas sueltas, leads que se enfrían y equipos apagando fuegos.\n\nNuestra respuesta es Aynara, una IA que:\n→ Atiende chat y teléfono con voz natural (y transcribe cada llamada)\n→ Detecta interés real y ofrece llamar al cliente en el momento exacto\n→ Prioriza todos los leads en un Panel de Ventas por nivel de interés\n→ Agenda, confirma y hace seguimiento sin intervención humana\n\nNo integramos una IA genérica: diseñamos sistemas para sectores donde la velocidad comercial marca la diferencia.\n\nPruébala en primera persona (experiencia 3D con voz):\nneuralia369.com/experiencia`,
  },
  {
    id: 'x',
    channel: 'X / Twitter (hilo corto)',
    text: `Tu negocio pierde leads mientras duermes.\n\nAynara no duerme:\n📞 llama con voz real\n💬 responde el chat\n📅 agenda citas\n🔥 te avisa cuando hay un lead caliente\n\nAsí es Neuralia 369 →  neuralia369.com/experiencia`,
  },
  {
    id: 'whatsapp',
    channel: 'WhatsApp (difusión a contactos)',
    text: `Hola 👋 Te comparto algo que acabamos de lanzar y creo que te puede interesar.\n\nSe llama Neuralia 369: una IA (Aynara) que atiende a tus clientes por chat y por TELÉFONO con voz real, agenda citas sola y te ordena todos los leads por nivel de interés.\n\nPuedes hablar con ella ahora mismo aquí (experiencia 3D con voz):\nneuralia369.com/experiencia\n\nSi quieres, te enseño en 15 minutos cómo aplicarla a tu negocio.`,
  },
  {
    id: 'google_ads',
    channel: 'Google Ads (titulares + descripciones)',
    text: `TITULARES (máx. 30 caracteres):\n1. Tu IA que vende 24/7\n2. Aynara: IA con voz real\n3. Automatiza y vende más\n4. IA para tu negocio\n5. Deja de perder leads\n\nDESCRIPCIONES (máx. 90 caracteres):\n1. Aynara responde chat y teléfono, agenda citas y prioriza tus leads. Pruébala gratis.\n2. La capa de IA que une ventas, atención y operaciones. Vive la experiencia 3D.\n3. Detecta interés real y llama a tus clientes al momento. Neuralia 369.`,
  },
  {
    id: 'meta_ads',
    channel: 'Meta Ads (texto principal del anuncio)',
    text: `¿Cuántos clientes te escriben… y se enfrían porque nadie respondió a tiempo?\n\nAynara, la IA de Neuralia 369, responde al instante por chat y por teléfono con voz real, detecta quién quiere comprar y te lo pone el primero de la lista.\n\n🎯 Panel de Ventas con leads ordenados por interés\n📞 Llamadas automáticas con resumen de lo que quiere el cliente\n📅 Citas agendadas sin que muevas un dedo\n\nHabla con ella ahora (sí, con tu voz) → neuralia369.com/experiencia`,
  },
];

const CopyButton = ({ text, id }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // portapapeles no disponible
    }
  };
  return (
    <button type="button" onClick={copy} className="btn-secondary !px-3 !py-1.5 text-xs inline-flex items-center gap-1.5" data-testid={`campaign-copy-${id}`}>
      {copied ? <Check className="w-3.5 h-3.5 text-green-400" /> : <Copy className="w-3.5 h-3.5" />} {copied ? 'Copiado' : 'Copiar'}
    </button>
  );
};

export const CampaignKitHub = () => (
  <div className="space-y-6" data-testid="admin-campaign-kit">
    <div>
      <h3 className="text-text-heading font-heading text-lg font-semibold flex items-center gap-2">
        <Megaphone className="w-5 h-5 text-primary" /> Kit de Campaña de Lanzamiento
      </h3>
      <p className="text-sm text-text-muted">Textos e imágenes listos para copiar, descargar y publicar en tus redes y anuncios.</p>
    </div>

    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">🎬 Spot de lanzamiento (corregido, listo para Reels / TikTok)</p>
      <div className="glass-card p-4 flex flex-col sm:flex-row items-center gap-5" data-testid="campaign-video-card">
        <video src="/campaign/spot-lanzamiento-reels.mp4" controls className="w-40 rounded-xl border border-border-subtle" />
        <div className="flex-1">
          <p className="text-sm text-text-heading font-medium mb-1">Spot "La Quinta Revolución" — 30s vertical 1080×1920</p>
          <p className="text-xs text-text-muted mb-3">Subtítulos corregidos (sin erratas), marca unificada "Neuralia 369" y cierre limpio con logo. Formato ideal para Reels, TikTok, Shorts y Estados de WhatsApp.</p>
          <a href="/campaign/spot-lanzamiento-reels.mp4" download className="btn-secondary !px-4 !py-2 text-xs inline-flex items-center gap-1.5" data-testid="campaign-video-download">
            <Download className="w-3.5 h-3.5" /> Descargar vídeo
          </a>
        </div>
      </div>
    </div>

    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3 flex items-center gap-2"><ImageIcon className="w-4 h-4" /> Imágenes (clic para descargar)</p>
      <div className="grid md:grid-cols-3 gap-4">
        {IMAGES.map((img) => (
          <a key={img.file} href={img.file} download className="glass-card overflow-hidden group" data-testid={`campaign-image-${img.file.split('/').pop().split('.')[0]}`}>
            <img src={img.file} alt={img.label} className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-300" />
            <div className="p-3">
              <p className="text-sm text-text-heading font-medium flex items-center gap-1.5"><Download className="w-3.5 h-3.5 text-primary" /> {img.label}</p>
              <p className="text-xs text-text-muted mt-1">{img.format}</p>
            </div>
          </a>
        ))}
      </div>
    </div>

    <div className="space-y-4">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-primary">Textos listos para publicar</p>
      {TEXTS.map((item) => (
        <div key={item.id} className="glass-card p-5" data-testid={`campaign-text-${item.id}`}>
          <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
            <p className="text-sm font-semibold text-text-heading">{item.channel}</p>
            <CopyButton text={item.text} id={item.id} />
          </div>
          <pre className="whitespace-pre-wrap text-sm text-text-body font-sans bg-slate-950/50 rounded-xl p-4 border border-border-subtle max-h-64 overflow-y-auto">{item.text}</pre>
        </div>
      ))}
    </div>
  </div>
);

export default CampaignKitHub;
